import { FeatureItem } from './feature-item';

export function Features({ items, light = false, noDivider = false }) {
  return (
    <div className={light ? 'flex flex-col gap-4' : 'space-y-0'}>
      {items.map((feature, index) => (
        <FeatureItem
          key={index}
          icon={feature.icon}
          title={feature.title}
          description={feature.description}
          showDivider={!noDivider && index < items.length - 1}
          light={light}
        />
      ))}
    </div>
  );
}
